import { AlertIcon } from '@/components/icons';
import { useApiHealth } from './useApiHealth';

/**
 * Site-wide bar shown while the API or its database can't be reached. Learners can keep coding (the editor
 * autosaves on this device); only saving progress and signing in wait for the server.
 */
export function ServiceBanner() {
  const { down } = useApiHealth();
  if (!down) return null;
  return (
    <div
      role="status"
      className="flex items-start gap-2 border-b border-line bg-danger-soft px-4 py-2.5 text-sm text-danger-ink md:items-center md:px-8"
    >
      <AlertIcon size={18} className="mt-px shrink-0 md:mt-0" />
      <p className="m-0">
        <strong className="font-semibold">Can’t reach the server.</strong> You can keep coding; your code is
        saved on this device. Progress and sign-in will work again once it’s back.
      </p>
    </div>
  );
}
